import React from "react";
import { useLang } from "../i18n";

const HERO = "/images/hero_couple.jpg";

export default function Hero() {
  const { t } = useLang();
  return (
    <section data-testid="hero-section" className="relative min-h-[100svh] flex items-end overflow-hidden">
      <img
        data-testid="hero-image"
        src={HERO}
        alt="A couple walking hand in hand down a hidden Porto street toward the Dom Luís bridge"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      {/* Editorial scrims for legibility */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#1b2026]/90 via-[#1b2026]/35 to-[#1b2026]/10" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#1b2026]/55 via-transparent to-transparent" />

      <div className="relative w-full max-w-7xl mx-auto px-6 md:px-10 pb-20 md:pb-28 pt-36">
        <div className="max-w-3xl">
          <p data-testid="hero-eyebrow" className="hero-rise text-[11px] md:text-sm uppercase tracking-[0.34em] text-[#F7F1E8]/85 mb-6" style={{ animationDelay: "0.05s" }}>
            {t.hero.eyebrow}
          </p>
          <h1 data-testid="hero-headline" className="hero-rise font-serif-display text-[#FDFAF3] leading-[0.92] text-5xl sm:text-6xl md:text-7xl lg:text-[6.5rem]" style={{ animationDelay: "0.15s" }}>
            <span className="block">Porto</span>
            <span className="block italic font-light text-[#E7C9A4]">fora da</span>
            <span className="block">Postal</span>
          </h1>
          <div data-testid="hero-intl" className="hero-rise mt-5 flex items-center gap-4" style={{ animationDelay: "0.27s" }}>
            <span className="h-px w-10 md:w-16 bg-[#E7C9A4]/80 shrink-0" />
            <p className="font-serif-display text-2xl md:text-3xl lg:text-[2.6rem] leading-tight text-[#F7F1E8]">Porto Beyond the Postcard</p>
          </div>
          <p data-testid="hero-sub" className="hero-rise mt-7 text-base md:text-xl text-[#F7F1E8]/90 max-w-xl leading-relaxed" style={{ animationDelay: "0.38s" }}>
            {t.hero.paragraph}
          </p>
          <div className="hero-rise mt-9 flex flex-col sm:flex-row gap-3" style={{ animationDelay: "0.45s" }}>
            <a data-testid="hero-cta-primary" href="#booking"
              className="btn-sweep inline-flex items-center justify-center px-8 py-4 rounded-full bg-[#FDFAF3] text-[#2D3640] text-sm tracking-wider hover:bg-[#E7C9A4] transition-colors">
              {t.hero.ctaPrimary}
            </a>
            <a data-testid="hero-cta-secondary" href="#story"
              className="inline-flex items-center justify-center px-8 py-4 rounded-full border border-[#FDFAF3]/45 text-[#FDFAF3] text-sm tracking-wider hover:bg-[#FDFAF3]/10 transition-colors">
              {t.hero.ctaSecondary}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
